import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: center;
  justify-content: center;
  height: 100%;

  row-gap: 8px;
`;

export const RowButton = styled.button`
  display: flex;
  flex-direction: row;
  height: 42px;
  gap: 8px;
  border: 0;
  background-color: transparent;
  padding: 10px 16px;
  align-items: center;
  [data-disabled],
  [data-disabled] * {
    cursor: not-allowed;
  }
`;

export const Open = styled.div`
  font-size: 14px;
  font-weight: 500;
  color: #1371fe;
  align-items: center;
  text-align: center;
`;

export const Text = styled.div`
  font-size: 14px;
  font-weight: 500;
  color: #1371fe;
  align-items: center;
  text-align: center;

  &.heavy {
    color: #474d66;
    margin-bottom: 8px;
  }

  &.light {
    font-weight: 400;
    color: #474d66;
  }
`;

export const LinkText = styled.a`
  font-size: 14px;
  font-weight: 400;
  color: #1371fe;
`;
